export default "__VITE_ASSET__EsSyonNWXFChOyjfj2S3nw__"